export const traceabilityDe = {
  title: 'Chargengenealogie und Rückverfolgung',
  subtitle:
    'Verbrauchte und erzeugte Chargen über alle Produktionsstufen verfolgen und Recall-Auswirkungen bewerten.',
  help: { open: 'Hilfe zu Chargengenealogie und Recall-Simulationen öffnen' },
  tabs: { trace: 'Chargen verfolgen', simulations: 'Recall-Simulationen' },
  filters: {
    title: 'Rückverfolgungsfilter',
    description:
      'Mindestens eine Charge, einen Artikel, Partner oder Produktionsauftrag wählen. Alle Filter sind mandantengebunden.',
    batch: 'Charge',
    batchNumber: 'Chargennummer enthält',
    product: 'Artikel',
    supplier: 'Lieferant',
    customer: 'Kunde',
    productionOrder: 'Produktionsauftrag',
    from: 'Eingang ab',
    to: 'Eingang bis',
    direction: 'Richtung',
    depth: 'Maximale Ebenen',
    any: 'Alle',
  },
  directions: {
    FORWARD: 'Vorwärts bis zum Endprodukt',
    BACKWARD: 'Rückwärts bis zum Rohstoff',
    BOTH: 'Beide Richtungen',
  },
  relations: {
    ANCHOR: 'Startcharge',
    UPSTREAM: 'Vorgelagerter Rohstoff',
    DOWNSTREAM: 'Nachgelagertes Produkt',
    BOTH: 'Beidseitig verbunden',
  },
  batchStatuses: {
    FREE: 'Freigegeben',
    QUARANTINE: 'Quarantäne',
    BLOCKED: 'Gesperrt',
    EXPIRED: 'Abgelaufen',
    DEPLETED: 'Aufgebraucht',
  },
  actions: {
    calculate: 'Rückverfolgung starten',
    reset: 'Filter zurücksetzen',
    createSimulation: 'Recall-Simulation anlegen',
    review: 'Prüfen',
    cancel: 'Stornieren',
    confirmBlocks: 'Betroffene Chargen sperren',
    export: 'CSV exportieren',
  },
  messages: {
    invalidFilter: 'Die Rückverfolgungsfilter sind unvollständig.',
    simulationCreated: 'Recall-Simulation aus einem unveränderlichen Snapshot angelegt.',
    review: 'Recall-Simulation geprüft.',
    cancel: 'Recall-Simulation storniert.',
    blocksConfirmed: 'Betroffene Chargen mit Bestand wurden gesperrt.',
  },
  warnings: {
    truncatedTitle: 'Ergebnisgrenze erreicht',
    truncated:
      'Der Graph wurde an der gewählten Tiefe oder Sicherheitsgrenze abgeschnitten. Filter eingrenzen oder Tiefe erhöhen.',
  },
  stats: {
    lots: 'Betroffene Chargen',
    productionOrders: 'Produktionsaufträge',
    deliveries: 'Lieferungen',
    customers: 'Kunden',
  },
  graph: {
    title: 'Mehrstufiger Materialfluss',
    description: 'Pfeile folgen dem Materialfluss von verbrauchten zu erzeugten Chargen.',
    ariaLabel: 'Graph der vor- und nachgelagerten Chargen',
    snapshotTitle: 'Eingefrorener Genealogie-Snapshot',
    snapshotDescription:
      'Dieser Graph entspricht exakt dem Nachweis zum Erstellzeitpunkt der Simulation.',
  },
  impact: {
    title: 'Betroffene Bestände, Belege und Partner',
    description:
      'Die Auswirkung wird aus der vollständigen Menge rückverfolgter Chargen abgeleitet.',
    inventory: 'Lagerbestände',
    documents: 'Belege und Lieferungen',
    partners: 'Partner',
    productionOrders: 'Produktionsaufträge',
    suppliers: 'Lieferanten',
    customers: 'Kunden',
    snapshotTitle: 'Eingefrorene Impact-Analyse',
  },
  columns: {
    article: 'Artikel',
    batch: 'Charge',
    relation: 'Beziehung',
    status: 'Status',
    warehouse: 'Lager / Platz',
    available: 'Verfügbar',
    document: 'Beleg',
    type: 'Art',
    customer: 'Kunde',
    date: 'Datum',
    batches: 'Chargen',
    productionOrder: 'Produktionsauftrag',
    product: 'Produkt',
    completed: 'Beendet',
  },
  empty: {
    inventory: 'Keine betroffenen Lagerbestände.',
    documents: 'Keine betroffenen Belege.',
    partners: 'Keine betroffenen Partner.',
    orders: 'Keine betroffenen Produktionsaufträge.',
    trace: 'Rückverfolgungsfilter wählen, um die Chargengenealogie anzuzeigen.',
    simulations: 'Keine Recall-Simulationen gefunden.',
    selectSimulation: 'Eine Recall-Simulation auswählen.',
  },
  simulations: {
    search: 'Nummer, Titel oder Grund suchen',
    allStatuses: 'Alle Status',
    title: 'Gespeicherte Simulationen',
    description:
      'Jeder Eintrag bewahrt Graph, Auswirkungen, Filter und SHA-256-Nachweis unverändert auf.',
    noNotificationTitle: 'Keine externe Benachrichtigung',
    noNotification:
      'Dieser Workflow informiert weder Kunden noch Lieferanten oder Behörden. Externe Kommunikation erfordert eine separate, ausdrückliche und berechtigte Aktion.',
  },
  statuses: {
    DRAFT: 'Entwurf',
    REVIEWED: 'Geprüft',
    BLOCKS_CONFIRMED: 'Chargen gesperrt',
    CANCELLED: 'Storniert',
  },
  fields: {
    title: 'Titel',
    reason: 'Grund',
    note: 'Entscheidungsnotiz',
    createdAt: 'Angelegt',
    direction: 'Rückverfolgungsrichtung',
    snapshotHash: 'Snapshot SHA-256',
    blockedBatches: 'Gesperrte Chargen',
  },
  create: {
    title: 'Recall-Simulation anlegen',
    description:
      'Aktueller Graph und Auswirkungen werden als unveränderlicher Snapshot eingefroren. Es wird noch keine Charge gesperrt.',
  },
  workflow: {
    review: {
      title: 'Recall-Simulation prüfen',
      description:
        'Bestätigen, dass die eingefrorenen Auswirkungen anhand der verfügbaren Nachweise geprüft wurden.',
    },
    cancel: {
      title: 'Recall-Simulation stornieren',
      description:
        'Der Snapshot bleibt für die Revision erhalten; betroffene Chargen werden nicht verändert.',
    },
  },
  block: {
    title: 'Betroffene Chargen ausdrücklich sperren',
    description:
      '{{count}} betroffene Charge(n) mit Bestand werden geprüft und transaktional gesperrt.',
    notificationTitle: 'Externe Kommunikation ist ausgeschlossen',
    notificationDescription:
      'Die Bestandssperre versendet keine E-Mails, Nachrichten oder Behördenmeldungen.',
    confirmLots:
      'Ich bestätige ausdrücklich, dass alle betroffenen Chargen mit Bestand gesperrt werden sollen.',
    confirmNoNotification:
      'Ich habe verstanden, dass durch diese Aktion keine externe Benachrichtigung versendet wird.',
  },
} as const;
